export function initOrderSlipLabLines(form: Element) {
  const container = form.querySelector("[data-order-slip-custom-lab-lines]");
  const button = form.querySelector("[data-order-slip-add-lab]");

  const addLine = () => {
    const inputs = container?.querySelectorAll<HTMLInputElement>("input");
    const firstInput = inputs?.[0];
    if (!firstInput || !container || !inputs) return;

    const input = firstInput.cloneNode(true) as HTMLInputElement;
    input.removeAttribute("id");
    input.value = "";
    input.dataset.orderSlipArrayIndex = String(inputs.length);
    input.placeholder = `Lab ${inputs.length + 1}`;
    input.setAttribute("aria-label", input.placeholder);
    container.append(input);
    input.focus();
  };

  button?.addEventListener("click", addLine);
  return () => button?.removeEventListener("click", addLine);
}
